/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
.toaster {
  position: fixed;
  right: 10px;
  bottom: 10px;
  max-width: 550px;
  background-color: #292929;
  z-index: 5000;
  box-shadow: 1px 1px 5px 0px black;
  color: #f6f8fa;
  border-radius: 4px;
}

.toaster-content {
  border-right: 1px solid #413b3b;
}

.toaster-link {
  color: #f6f8fa;
}
